type FavouriteIconProps = {
  active?: boolean;
  width?: number | string;
  height?: number | string;
  className?: string;
};

export default function FavouriteIcon({
  active,
  width = '100%',
  height = '100%',
  className,
}: FavouriteIconProps) {
  return active ? (
    // Filled heart
    <svg
      height={height}
      width={width}
      viewBox="0 0 122.88 107.41"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none">
      <g>
        <path
          d="M60.83,17.19C68.84,8.84,74.45,1.62,86.79,0.21c23.17-2.66,44.48,21.06,32.78,44.41 c-3.33,6.65-10.11,14.56-17.61,22.32c-8.23,8.52-17.34,16.87-23.72,23.2l-17.4,17.26L46.46,93.56C29.16,76.9,0.95,55.93,0.02,29.95 C-0.63,11.75,13.73,0.09,30.25,0.3C45.01,0.5,51.22,7.84,60.83,17.19L60.83,17.19L60.83,17.19z"
          fill="currentColor"
        />
      </g>
    </svg>
  ) : (
    // Outline heart
    <svg
      height={height}
      width={width}
      viewBox="-5 0 132.88 109.57"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none">
      <g>
        <path
          d="M60.77,14.85C67.67,7.54,73.4,1.55,85.04,0.22c6.72-0.77,13.3,0.57,19.03,3.45 c4.95,2.48,9.27,6.1,12.51,10.47c3.27,4.42,5.46,9.61,6.1,15.19c0.65,5.66-0.29,11.69-3.3,17.69c-1.7,3.39-4.22,7.03-7.23,10.76 c-2.95,3.66-6.39,7.44-10,11.17C97.2,74.08,91.94,79.12,87.2,83.66c-2.77,2.65-5.36,5.13-7.54,7.29L63.2,107.28l-2.31,2.29 l-2.34-2.25l-13.6-13.1c-2.49-2.39-5.37-5.02-8.36-7.75C20.38,71.68,0.81,53.85,0.02,31.77C0,31.23,0,30.67,0,30.09 c0.12-8.86,3.66-16.18,9.21-21.36c5.5-5.13,12.97-8.13,21.01-8.42c0.55-0.02,1.13-0.03,1.74-0.02C46,0.48,52.42,6.63,60.77,14.85 L60.77,14.85z"
          stroke="white"
          strokeWidth="7"
          fill="rgba(255, 255, 255, 0.25)"
        />
      </g>
    </svg>
  );
}
